import { render, staticRenderFns } from "./PlateHistory.vue?vue&type=template&id=b8b1d54a&"
import script from "./PlateHistory.vue?vue&type=script&lang=js&"
export * from "./PlateHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports